<template>
  <v-card class="create-nsr-item">
    <v-card-title> Edit NSR Item Config </v-card-title>
    <v-card-text class="d-flex flex-column overflow-auto">
      <v-form ref="form">
        <v-select
          v-if="nsrConfig"
          v-model="nsrConfig.selected_dataset"
          :items="dataset"
          chips
          label="Datasets"
          multiple
          outlined
          style="margin-top: 1rem"
        ></v-select>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save" depressed large>
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref, computed } from "@vue/composition-api/dist/vue-composition-api";
import { ACTION_TYPES } from "@/store/types";
import { onMounted } from "@vue/composition-api";

export default {
  name: "NsrConfigDialog",
  components: {},
  setup(props, { root, emit }) {
    const dataset = ref([]);
    const nsrConfig = ref(undefined);
    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/nsr/set_config/",
        params: {
          ...nsrConfig.value,
        },
      });
      if (response.body.success) {
        emit("submit", true);
      }
    };

    const getNsrConfig = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/nsr/get_selected_dataset/",
        params: {},
      });

      if (response && response.data && response.data.success) {
        nsrConfig.value = response.data.nsr_config;
      }
    };

    const getDataset = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/",
        params: {},
      });

      if (response && response.data && response.data.success) {
        dataset.value = response.data.datasets.map((d) => {
          return {
            text: `[${d.alias}]`,
            value: d.id,
          };
        });
      }
    };

    onMounted(() => {
      getNsrConfig();
      getDataset();
    });

    return {
      save,
      dataset,
      nsrConfig,
    };
  },
};
</script>
<style lang="less">
.create-nsr-item {
  display: flex;
  flex-direction: column;
  height: auto;
}
</style>
